import {
  AddressInfo,
  AddressDto,
  DesignationInfo,
  DesignationDto,
  PreDesignationDto,
  EmployeeInfo,
  CompanyDto,
  EmployeeDtoProfile,
  EmployeeDtoProof,
  InitialValues,
} from "../../../../employee/employee-details/employee-profile/layout/edit-employee/types/EditEmployeeDetailsTypes";

const imageBaseUrl = process.env.REACT_APP_IMAGE_VIEW;

const createAddress = (addressInfo: AddressInfo | undefined): AddressDto => {
  return {
    doorNo: addressInfo?.doorNo ?? "",
    street: addressInfo?.street ?? "",
    city: addressInfo?.city ?? "",
    state: addressInfo?.state ?? "",
    pinCode: addressInfo?.pinCode ?? "",
    addressId: addressInfo?.addressId ?? "",
  };
};
const createDesignationDto = (designationInfo: any | undefined): DesignationDto => {
  return {
    designationId: designationInfo?.designationId ?? "",
    grade: designationInfo?.grade?.name ?? "",
    designationName: designationInfo?.name ?? "",
  };
};

const createPreDesignationDto = (designationInfo: DesignationInfo | undefined): PreDesignationDto => {
  return {
    preDesignationId: designationInfo?.designationId ?? "",
  };
};

const createStatusDto = (statusInfo: any | undefined): any => {
  return {
    statusId: statusInfo?.statusId ?? "",
    statusName: statusInfo?.name ?? "", // StatusDto does not have statusName in the interface definition provided
  };
};
const createCompanyDto = (info: any): any => {
  // Parsing info as any because the input object structure is complex and nested differently from strict types sometimes
  // However, we can use EmployeeInfo if we are sure it covers all fields.
  // For now, keeping input as any to avoid breaking existing calls, but return type is strongly typed.
  return {
    dateOfJoin: info?.dateOfJoin ?? "",
    designationEffectiveDate: "",
    nextProbationEndDate: info?.nextProbationEndDate ?? "",
    reportingManagerId: info?.reportingManager?.employeeId ?? "",
    reportingManagerName: `${info?.reportingManager?.firstName ?? ""} ${info?.reportingManager?.lastName ?? ""}`.trim() || " NA", // key not in CompanyDto

    initiatingManagerId: info?.initiationManager?.employeeId ?? "",
    backGroundVerification: info?.backGroundVerification ?? "",
    grade: info?.designation?.grade?.name ?? "",
    designationDto: createDesignationDto(info?.designation),
    preDesignationDto: createPreDesignationDto(info?.designation),
    statusDto: createStatusDto(info?.status),
    departmentId: info?.department?.departmentId ?? "",
    departmentName: info?.department?.description ?? "", // key not in CompanyDto
    employeeTypeId: info?.employeeType?.employeeTypeId ?? "",
    employeeTypeName: info?.employeeType?.typeofEmployment ?? "", // key not in CompanyDto
    officialEmailId: info?.officialEmail ?? "",
  };
};
const createEmployeeDtoProfile = (info: EmployeeInfo): EmployeeDtoProfile => {
  return {
    firstName: info?.firstName ?? "",
    lastName: info?.lastName ?? "",
    dateOfBirth: info?.dateOfBirth ?? "",
    bloodGroup: info?.bloodGroup ?? "",
    fatherOrSpouseName: info?.fatherOrSpouseName ?? "",
    fatherName: info?.fatherName ?? "",
    motherName: info?.motherName ?? "",
    personalContactNo: info?.personalContactNo ?? "",
    personalEmail: info?.personalEmail ?? "",
  };
};
const createEmployeeDtoProof = (info: EmployeeInfo): EmployeeDtoProof => {
  return {
    aadharNumber: info?.aadharNumber ?? "",
    panNumber: info?.panNumber ?? "",
    uanNumber: info?.uanNumber ?? "",
    esiNumber: info?.esiNumber ?? "",
    gender: info?.gender ?? "M",
    isMarried: info?.isMarried ?? false,
    sameAsCurrentAddress: info?.sameAsCurrentAddress ?? "",
    presentAddress: createAddress(info?.presentAddress),
    permanentAddress: createAddress(info?.permanentAddress),
    emergencyContactNo1: info?.emergencyContactNo1 ?? "",
    emergencyContactNo1Relationship: info?.emergencyContactNo1Relationship ?? "",
    emergencyContactNo2: info?.emergencyContactNo2 ?? "",
    emergencyContactNo2Relationship: info?.emergencyContactNo2Relationship ?? "",
    identificationMark: info?.identificationMark ?? "",
  };
};

export const handleSetInitialUserValues = (
  info: EmployeeInfo,
  setEmployeeImage: (url: string) => void,
  setInitialvalues: (values: InitialValues) => void,
  setCompantDto: (dto: CompanyDto) => void,
) => {
  const empInfo: InitialValues = {
    employeeDto: {
      ...createEmployeeDtoProfile(info),
      ...createEmployeeDtoProof(info),
    },
    companyDto: createCompanyDto(info),
    assertId: info?.employeeAssertInfo?.assertId ?? "",
  };
  setEmployeeImage(`${imageBaseUrl}${info?.profileUrl}`);
  setInitialvalues(empInfo);
  setCompantDto(empInfo?.companyDto);
};
